import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('transactions', app)
  return store
}
